import { render } from "./legoTableExtend.vue?vue&type=template&id=10142f00&scoped=true"
import script from "./legoTableExtend.vue?vue&type=script&lang=js"
export * from "./legoTableExtend.vue?vue&type=script&lang=js"

import "./legoTableExtend.vue?vue&type=style&index=0&id=10142f00&lang=scss&scoped=true"
import "./legoTableExtend.vue?vue&type=style&index=1&id=10142f00&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10142f00"],['__file',"src/components/lego/extend/legoTableExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10142f00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10142f00', __exports__)) {
    api.reload('10142f00', __exports__)
  }
  
  module.hot.accept("./legoTableExtend.vue?vue&type=template&id=10142f00&scoped=true", () => {
    api.rerender('10142f00', render)
  })

}


export default __exports__